import React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { SiteSettingsForServerAdminProps } from '../ReactSiteSettingsForServerAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export type PerformanceMetricsSectionProps = SiteSettingsForServerAdminProps<'metricsEnabled'>;

export const PERFORMANCE_METRICS_FIELD = 'settings.metricsEnabled';

export function PerformanceMetricsSection(props: PerformanceMetricsSectionProps) {
  return (
    <SettingsSection title={Messages.workbookPerformanceMetrics()}
                     description={Messages.workbookPerformanceMetricsDetails()}>

      <FormikCheckbox name={PERFORMANCE_METRICS_FIELD}
                      label={Messages.recordWorkbookPerformance()}
                      testId={'allow-performance-recording-checkbox'}/>

    </SettingsSection>
  );
}

export const PerformanceMetricsSectionSpecs = componentRegistryEntry({
  name: 'PerformanceMetricsSection',
  component: PerformanceMetricsSection
});
